export const KEY_DOWN = 40,
  KEY_UP = 38,
  KEY_RIGHT = 39,
  KEY_LEFT = 37,
  ESC = 27,
  ENTER = 13,
  KEY_TAB = 9,
  KEY_HOME = 36,
  KEY_END = 35,
  KEY_PGDOWN = 34,
  KEY_SPACE = 32;

const commandKeyRe = /^..+$/; // Keys performing commands have more
// than a single letter. For these // keys we want the ShiftKey info as S-.

export const ctrlPressed = event =>
  (event.ctrlKey || event.metaKey) &&
  event.key !== "Control" &&
  event.key !== "CapsLock";

/**
 * @function
 * @param {Object} event
 * Return C-M-S-<key> for a keydown event, where any of C- (control), M- (alt) or S- (shift) could be omitted.
 * Omit S- even when pressed if it's just a character being output.
 * If it's a click event, 'Click', 'C-Click', etc. are returned.
 */
export const eventKey = event => {
  let key;
  if (!event) return null;
  if (event.type === "click") key = "Click";
  else key = event.key === " " ? "Space" : event.key;
  return [
    ctrlPressed(event) && "C",
    event.altKey && key !== "Alt" && "M",
    event.shiftKey && commandKeyRe.test(key) && key !== "Shift" && "S",
    key
  ]
    .filter(Boolean)
    .join("-");
};

const mac =
  navigator.platform.indexOf("Mac") === 0 ||
  navigator.platform.indexOf("i") === 0;

export const isMac = () => mac;

export const ArrowStart = "ArrowStart";
export const ArrowEnd = "ArrowEnd";

const logicalLookup = {
  ltr: {
    ArrowLeft: ArrowStart,
    ArrowRight: ArrowEnd,
    ArrowUp: ArrowStart,
    ArrowDown: ArrowEnd
  },
  rtl: {
    ArrowLeft: ArrowEnd,
    ArrowRight: ArrowStart,
    ArrowUp: ArrowStart,
    ArrowDown: ArrowEnd
  }
};

export const logicalArrow = event => {
  const { direction } = window.getComputedStyle(event.target);
  return logicalLookup[direction][event.key];
};
